
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/ntc-story",
      function () {
        return require("private-next-pages/stories/ntc-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/ntc-story"])
      });
    }
  